import { MARKETPLACE_BUSINESS_CATEGORIES } from '@/app/pages/marketplace/constants'

type GetAcceptingNewClientsLabelArgs = {
  isAcceptingNewClients: boolean
  businessCategoryName: string
}

export const getAcceptingNewClientsLabelKey = ({
  isAcceptingNewClients,
  businessCategoryName,
}: GetAcceptingNewClientsLabelArgs) => {
  const isSchool =
    businessCategoryName === MARKETPLACE_BUSINESS_CATEGORIES.SCHOOL

  if (isAcceptingNewClients) {
    return isSchool ? 'accepting_new_students' : 'accepting_new_clients'
  }

  return isSchool ? 'not_accepting_new_students' : 'not_accepting_new_clients'
}

export type StoreScope = 'my_schools' | 'all'

export type StoreScopeFlags = {
  hasStudents: boolean
  hasSchoolLinks: boolean
}

type ResolveStoreScopeArgs = {
  selectedScope: StoreScope
  // null until the API has reported the flags, or when it doesn't support
  // scoping yet; the stores then load unscoped and the toggle stays hidden.
  flags: StoreScopeFlags | null
}

export const resolveStoreScope = ({
  selectedScope,
  flags,
}: ResolveStoreScopeArgs) => {
  const canScopeToMySchools = flags?.hasSchoolLinks === true

  return {
    requestMySchools:
      selectedScope === 'my_schools' && (flags === null || canScopeToMySchools),
    showScopeToggle: canScopeToMySchools,
    showAddStudentPrompt: flags?.hasStudents === false,
  }
}
